module.exports = __webpack_public_path__ + "static/media/bicycle.5c6ac776.svg";